import offlineDb from "../db/appDb";

function toSafeScopeKey(scopeKey) {
  return String(scopeKey || "").trim();
}

function toSafeCacheKey(cacheKey) {
  return String(cacheKey || "").trim();
}

function toSafeWorkorderId(workorderId) {
  return String(workorderId || "").trim();
}

function createUpdatedAt() {
  return new Date().toISOString();
}

export function createMonteurScopeKey(user = {}) {
  const tenantId = String(user?.tenantId || user?.tenant || "").trim() || "tenant";
  const userId =
    String(user?._id || user?.id || user?.userId || user?.sub || user?.email || "").trim() ||
    "user";
  return `${tenantId}:${userId}`;
}

export async function getCachedWorkorderCollection({ scopeKey, cacheKey }) {
  const safeScopeKey = toSafeScopeKey(scopeKey);
  const safeCacheKey = toSafeCacheKey(cacheKey);
  if (!safeScopeKey || !safeCacheKey) return null;
  return offlineDb.workorderCollections.get([safeScopeKey, safeCacheKey]);
}

export async function setCachedWorkorderCollection({ scopeKey, cacheKey, payload }) {
  const safeScopeKey = toSafeScopeKey(scopeKey);
  const safeCacheKey = toSafeCacheKey(cacheKey);
  if (!safeScopeKey || !safeCacheKey) return null;

  const record = {
    scopeKey: safeScopeKey,
    cacheKey: safeCacheKey,
    payload: Array.isArray(payload) ? payload : [],
    updatedAt: createUpdatedAt(),
  };

  await offlineDb.workorderCollections.put(record);
  return record;
}

export async function getCachedWorkorderDetail({ scopeKey, workorderId }) {
  const safeScopeKey = toSafeScopeKey(scopeKey);
  const safeWorkorderId = toSafeWorkorderId(workorderId);
  if (!safeScopeKey || !safeWorkorderId) return null;
  return offlineDb.workorderDetails.get([safeScopeKey, safeWorkorderId]);
}

export async function setCachedWorkorderDetail({ scopeKey, workorderId, payload }) {
  const safeScopeKey = toSafeScopeKey(scopeKey);
  const safeWorkorderId = toSafeWorkorderId(workorderId);
  if (!safeScopeKey || !safeWorkorderId) return null;

  const record = {
    scopeKey: safeScopeKey,
    workorderId: safeWorkorderId,
    payload: payload || null,
    updatedAt: createUpdatedAt(),
  };

  await offlineDb.workorderDetails.put(record);
  return record;
}

export async function getCachedWorkorderFinancial({ scopeKey, workorderId }) {
  const safeScopeKey = toSafeScopeKey(scopeKey);
  const safeWorkorderId = toSafeWorkorderId(workorderId);
  if (!safeScopeKey || !safeWorkorderId) return null;
  return offlineDb.workorderFinancial.get([safeScopeKey, safeWorkorderId]);
}

export async function setCachedWorkorderFinancial({ scopeKey, workorderId, payload }) {
  const safeScopeKey = toSafeScopeKey(scopeKey);
  const safeWorkorderId = toSafeWorkorderId(workorderId);
  if (!safeScopeKey || !safeWorkorderId) return null;

  const record = {
    scopeKey: safeScopeKey,
    workorderId: safeWorkorderId,
    payload: payload || {},
    updatedAt: createUpdatedAt(),
  };

  await offlineDb.workorderFinancial.put(record);
  return record;
}

export async function getCachedReferenceData({ scopeKey, type }) {
  const safeScopeKey = toSafeScopeKey(scopeKey);
  const safeType = String(type || "").trim();
  if (!safeScopeKey || !safeType) return null;
  return offlineDb.referenceData.get([safeScopeKey, safeType]);
}

export async function setCachedReferenceData({ scopeKey, type, payload }) {
  const safeScopeKey = toSafeScopeKey(scopeKey);
  const safeType = String(type || "").trim();
  if (!safeScopeKey || !safeType) return null;

  const record = {
    scopeKey: safeScopeKey,
    type: safeType,
    payload,
    updatedAt: createUpdatedAt(),
  };

  await offlineDb.referenceData.put(record);
  return record;
}
